var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftCardsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1576,
    height: 542,
    viewBox: "0 0 1576 542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_1160",
    x: 313,
    y: 387,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_1160-2",
    x: 879,
    y: 387,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_1160-3",
    x: 1445,
    y: 387,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "card__body",
    x: 0,
    y: 0,
    width: 444,
    height: 542,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trazado_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1160-4",
    "data-name": "Trazado 1160",
    d: "M35,0A35,35,0,1,1,0,35,35,35,0,0,1,35,0Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "card__body-2",
    x: 566,
    y: 0,
    width: 444,
    height: 542,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "card__body-3",
    x: 1132,
    y: 0,
    width: 444,
    height: 542,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nft-cards",
    transform: "translate(9 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -2)",
    filter: "url(#card__body)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "card__body-4",
    "data-name": "card__body",
    d: "M32,0H394a32,32,0,0,1,32,32V505a19,19,0,0,1-19,19H19A19,19,0,0,1,0,505V32A32,32,0,0,1,32,0Z",
    transform: "translate(9 3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "card_top-box",
    d: "M32,0H394a32,32,0,0,1,32,32V425a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V32A32,32,0,0,1,32,0Z",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "card_body-right",
    transform: "translate(319 390)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1157",
    "data-name": "Trazado 1157",
    d: "M13549.623-1198.678l-.123-36.559,3.137-1.062,1.459,2.579Z",
    transform: "translate(-13514.613 1233.853)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1158",
    "data-name": "Trazado 1158",
    d: "M13459.354-1205.373l1.115,25.418-19.791,20.253-36.6,1.151-17.26-28.768v-29.689l29.689-12.658,7.314-.712v36.181Z",
    transform: "translate(-13388.789 1229.273)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1159",
    "data-name": "Trazado 1159",
    d: "M13553.774-1224.318l27.847.651,3.351,23.262-35.588,10.929Z",
    transform: "translate(-13514.372 1224.586)",
    fill: "#b6b6b6"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_Preset_1_",
    "data-name": "[Preset 1]",
    transform: "translate(377 479.06)",
    fill: "#707070",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -63,
    y: 0
  }, "[Preset 1]")), /*#__PURE__*/React.createElement("g", {
    id: "card__body-left",
    transform: "translate(38 493)",
    fill: "#fff",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 23,
    rx: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 22,
    rx: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Buy",
    transform: "translate(67 509)",
    fill: "#6f6f6f",
    fontSize: 13,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10,
    y: 0
  }, "Buy")), /*#__PURE__*/React.createElement("text", {
    id: "_0x25ac...66fc",
    "data-name": "0x25ac...66fc",
    transform: "translate(38 472.5)",
    fill: "#707070",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0x25ac...66fc")), /*#__PURE__*/React.createElement("text", {
    id: "_AVAX",
    "data-name": "[#] AVAX",
    transform: "translate(378 511)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -77,
    y: 0
  }, "[#] AVAX")), /*#__PURE__*/React.createElement("text", {
    id: "_NFT_Name_",
    "data-name": "[NFT Name]",
    transform: "translate(37 450.5)",
    fill: "#6f6f6f",
    fontSize: 20,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "[NFT Name]"))), /*#__PURE__*/React.createElement("g", {
    id: "card-2",
    "data-name": "card",
    transform: "translate(566)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -575, -2)",
    filter: "url(#card__body-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "card__body-5",
    "data-name": "card__body",
    d: "M32,0H394a32,32,0,0,1,32,32V505a19,19,0,0,1-19,19H19A19,19,0,0,1,0,505V32A32,32,0,0,1,32,0Z",
    transform: "translate(575 3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "card_top-box-2",
    "data-name": "card_top-box",
    d: "M32,0H394a32,32,0,0,1,32,32V425a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V32A32,32,0,0,1,32,0Z",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "card_body-right-2",
    "data-name": "card_body-right",
    transform: "translate(319 390)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1157-2",
    "data-name": "Trazado 1157",
    d: "M13549.623-1198.678l-.123-36.559,3.137-1.062,1.459,2.579Z",
    transform: "translate(-13514.613 1233.853)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1158-2",
    "data-name": "Trazado 1158",
    d: "M13459.354-1205.373l1.115,25.418-19.791,20.253-36.6,1.151-17.26-28.768v-29.689l29.689-12.658,7.314-.712v36.181Z",
    transform: "translate(-13388.789 1229.273)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1159-2",
    "data-name": "Trazado 1159",
    d: "M13553.774-1224.318l27.847.651,3.351,23.262-35.588,10.929Z",
    transform: "translate(-13514.372 1224.586)",
    fill: "#b6b6b6"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_Preset_1_2",
    "data-name": "[Preset 1]",
    transform: "translate(377 479.06)",
    fill: "#707070",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -63,
    y: 0
  }, "[Preset 1]")), /*#__PURE__*/React.createElement("g", {
    id: "card__body-left-2",
    "data-name": "card__body-left",
    transform: "translate(38 493)",
    fill: "#fff",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 23,
    rx: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 22,
    rx: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Buy-2",
    "data-name": "Buy",
    transform: "translate(67 509)",
    fill: "#6f6f6f",
    fontSize: 13,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10,
    y: 0
  }, "Buy")), /*#__PURE__*/React.createElement("text", {
    id: "_0x25ac...66fc-2",
    "data-name": "0x25ac...66fc",
    transform: "translate(38 472.5)",
    fill: "#707070",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0x25ac...66fc")), /*#__PURE__*/React.createElement("text", {
    id: "_AVAX-2",
    "data-name": "[#] AVAX",
    transform: "translate(378 511)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -77,
    y: 0
  }, "[#] AVAX")), /*#__PURE__*/React.createElement("text", {
    id: "_NFT_Name_2",
    "data-name": "[NFT Name]",
    transform: "translate(37 450.5)",
    fill: "#6f6f6f",
    fontSize: 20,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "[NFT Name]"))), /*#__PURE__*/React.createElement("g", {
    id: "card-3",
    "data-name": "card",
    transform: "translate(1132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1141, -2)",
    filter: "url(#card__body-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "card__body-6",
    "data-name": "card__body",
    d: "M32,0H394a32,32,0,0,1,32,32V505a19,19,0,0,1-19,19H19A19,19,0,0,1,0,505V32A32,32,0,0,1,32,0Z",
    transform: "translate(1141 3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "card_top-box-3",
    "data-name": "card_top-box",
    d: "M32,0H394a32,32,0,0,1,32,32V425a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V32A32,32,0,0,1,32,0Z",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "card_body-right-3",
    "data-name": "card_body-right",
    transform: "translate(319 390)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1157-3",
    "data-name": "Trazado 1157",
    d: "M13549.623-1198.678l-.123-36.559,3.137-1.062,1.459,2.579Z",
    transform: "translate(-13514.613 1233.853)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1158-3",
    "data-name": "Trazado 1158",
    d: "M13459.354-1205.373l1.115,25.418-19.791,20.253-36.6,1.151-17.26-28.768v-29.689l29.689-12.658,7.314-.712v36.181Z",
    transform: "translate(-13388.789 1229.273)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1159-3",
    "data-name": "Trazado 1159",
    d: "M13553.774-1224.318l27.847.651,3.351,23.262-35.588,10.929Z",
    transform: "translate(-13514.372 1224.586)",
    fill: "#b6b6b6"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_Preset_1_3",
    "data-name": "[Preset 1]",
    transform: "translate(377 479.06)",
    fill: "#707070",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -63,
    y: 0
  }, "[Preset 1]")), /*#__PURE__*/React.createElement("g", {
    id: "card__body-left-3",
    "data-name": "card__body-left",
    transform: "translate(38 493)",
    fill: "#fff",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 23,
    rx: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 22,
    rx: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Buy-3",
    "data-name": "Buy",
    transform: "translate(67 509)",
    fill: "#6f6f6f",
    fontSize: 13,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10,
    y: 0
  }, "Buy")), /*#__PURE__*/React.createElement("text", {
    id: "_0x25ac...66fc-3",
    "data-name": "0x25ac...66fc",
    transform: "translate(38 472.5)",
    fill: "#707070",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0x25ac...66fc")), /*#__PURE__*/React.createElement("text", {
    id: "_AVAX-3",
    "data-name": "[#] AVAX",
    transform: "translate(378 511)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -77,
    y: 0
  }, "[#] AVAX")), /*#__PURE__*/React.createElement("text", {
    id: "_NFT_Name_3",
    "data-name": "[NFT Name]",
    transform: "translate(37 450.5)",
    fill: "#6f6f6f",
    fontSize: 20,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "[NFT Name]"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftCardsDefault);
export default __webpack_public_path__ + "static/media/nft-cards-default.f99d356fb4f4f821b00c4e533a742cc5.svg";
export { ForwardRef as ReactComponent };